// The Tamara BNPL widget (snippets/tamara.liquid) renders inside an open
// shadow root, so traditional.css's selectors can't reach its background/
// border - only a script running inside that shadow root can. This injects
// a small override stylesheet there so the widget's box reads as cream/tan
// instead of its default solid-white card, matching the rest of the page.
(function () {
  function applyOverride(widget) {
    if (!widget.shadowRoot || widget.shadowRoot.getElementById('traditional-theme-override')) return;
    if (!widget.shadowRoot.querySelector('.tamara-summary-widget__container')) return;
    var style = document.createElement('style');
    style.id = 'traditional-theme-override';
    style.textContent = '.tamara-summary-widget__container{background-color:#f7f4ef !important;border-color:#e0d9d0 !important;color:#946848 !important}' +
      '.tamara-summary-widget__amount svg path{fill:#946848 !important}';
    widget.shadowRoot.appendChild(style);
  }

  function watch(widget) {
    applyOverride(widget);
    if (!widget.shadowRoot) return;
    new MutationObserver(function () { applyOverride(widget); }).observe(widget.shadowRoot, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('tamara-widget').forEach(watch);
  }

  if (customElements.get('tamara-widget')) {
    init();
  } else {
    customElements.whenDefined('tamara-widget').then(init);
  }
})();
